

















































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import { mapGetters } from "vuex";
import SideNavVue from "../components/Declaration/SideNav.vue";

interface TaxType {
    id: number | null;
    name?: string;
    children: TaxType[];
}

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "side-nav": SideNavVue,
    },
})

export default class PropertyTax extends Vue {
    getMonth() {
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if (attr === "房产税") {
                if (data[attr].taxInfoMethod === 1) return false
                else return true
            }

        });
    }
    activeTab: string = "";
    tax: any = {};
    priceDtoList: any = [];
    typeList = [
        { id: 1, name: "工业" },
        { id: 2, name: "商业及办公" },
        { id: 3, name: "住房" },
        { id: 4, name: "其他" },
    ]
    nameList = [
        { id: 1, name: "产权所有人" },
        { id: 2, name: "经营管理人" },
        { id: 3, name: "承典人" },
        { id: 4, name: "房屋代管人" },
        { id: 5, name: "房屋使用人" },
        { id: 6, name: "融资租赁承租人" },

    ]
    newRow: {
        no: string | number,
        originValue: string | number,
        rentOriginValue: string | number,
        rentIncome: string | number,
        taxationRatio: string | number,
        taxationBasis: string | number,
        taxItem: string | number,
        taxRate: string | number,
        currentTaxPay: string | number,
        codeDeduction: string | number,
        taxDeduction: string | number,
        currentTaxPaid: string | number,
        fillRefundTaxAmount: string | number,
        totalArea?: string | number,
        totalIncome?: string | number,
        declarationStartDate?: any,
        declarationEndDate?: any,
        contractStartDate?: any,
        contractEndDate?: any,
    } = {
            no: "",
            originValue: "",
            rentOriginValue: "",
            rentIncome: "",
            taxationRatio: "0.7",
            taxationBasis: "",
            taxItem: "",
            taxRate: "0.012",
            currentTaxPay: "",
            codeDeduction: "",
            taxDeduction: "",
            currentTaxPaid: "",
            fillRefundTaxAmount: "",
        };
    period: string = "";
    time: string = "";

    mounted() {
        this.activeTab = "PropertyTaxRent"

    }
    tableList: any = []
    newrow: any = {
        accountBookId: this.$store.state.accountBook.id,
        no: "",
        code: null,
        name: null,
        type: null,
        purpose: null,
        date: null,
        coveredArea: null,
        city: null,
        street: null,
        address: null,
        taxOffice: null,
        landCode: null,
    }
    changeTable3(row?: any, name?: any) {
        if (name === "time") {
            if (row.date != "") {
                row.date = this.$utils.simpleDateFormat(row.date, "d");
            }
        }
        const taxCopy = JSON.parse(JSON.stringify(row));
        Vue.axios
            .post(
                `property/tax/info/save`,
                taxCopy
            )
            .then(() => {
                this.fetchData();
            });
    }
    delTable3(id: number) {
        const taxCopy = JSON.parse(JSON.stringify(this.tax));
        Vue.axios
            .post(
                `property/tax/info/delete?id=${id}`,
            )
            .then(() => {
                this.fetchData();
            });
    }
    table3List: any = []
    addNewRow3() {
        if (this.$utils.notNull([
            this.newrow.no,
        ]) || this.$utils.notNull([
            this.newrow.code,
        ]) || this.$utils.notNull([
            this.newrow.name,
        ])
            || this.$utils.notNull([
                this.newrow.type,
            ])
            || this.$utils.notNull([
                this.newrow.date,
            ])
            || this.$utils.notNull([
                this.newrow.coveredArea,
            ])
            || this.$utils.notNull([
                this.newrow.city,
            ])
            || this.$utils.notNull([
                this.newrow.street,
            ])
            || this.$utils.notNull([
                this.newrow.address,
            ])
            || this.$utils.notNull([
                this.newrow.taxOffice,
            ]
                || this.$utils.notNull([
                    this.newrow.landCode,
                ])
            )
        ) {
            if (this.newrow.date != "" && this.newrow.date != null) {
                this.newrow.date = this.$utils.simpleDateFormat(this.newrow.date, "d");
            }
            this.$nextTick(() => {
                this.changeTable3(this.newrow)
                this.$nextTick(() => {
                    this.resetNewRow()
                })
            })
        } else {
            this.$message.warning("亲，请填写完整数据！");

        }
    }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 1) this.fetchData();
        else this.$router.push({ path: "/declaration" });
    }
    mainBodyList = [
        { id: 1, name: "增值税小规模纳税人" },
        { id: 2, name: "小型微利企业（增值税一般纳税人）" },
        { id: 3, name: "个体工商户（增值税一般纳税人）" },
    ]

    // 选择时间
    changeDate(start: string, end: string) {
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if (attr === "房产税") {
                if (data[attr].taxInfoMethod === 1) {
                    this.period = start
                }
                else {
                    this.period = end
                }
            }

        });
        this.resetNewRow()
        this.fetchData();
    }

    resetNewRow() {
        if (this.activeTab === "PropertyTaxRent") {
            this.newRow = {
                no: "",
                originValue: "",
                rentOriginValue: "",
                rentIncome: "",
                taxationRatio: "0.7",
                taxationBasis: "",
                taxItem: "从价计征",
                taxRate: "0.012",
                currentTaxPay: "",
                codeDeduction: "",
                taxDeduction: "",
                currentTaxPaid: "",
                fillRefundTaxAmount: "",
            };
        }
        else if (this.activeTab === "PropertyTaxPrice") {
            this.newRow = {
                no: "",
                originValue: "",
                rentOriginValue: "",
                rentIncome: "",
                taxationRatio: "",
                taxationBasis: "",
                taxItem: "从租计征",
                taxRate: "0.12",
                currentTaxPay: "",
                codeDeduction: "",
                taxDeduction: "",
                currentTaxPaid: "",
                fillRefundTaxAmount: "",
            }
        }
        else if (this.activeTab === "PropertyTaxInfo") {
            this.newrow = {
                no: "",
                accountBookId: this.$store.state.accountBook.id,
                code: null,
                name: null,
                type: null,
                purpose: null,
                date: null,
                coveredArea: null,
                city: null,
                street: null,
                address: null,
                taxOffice: null,
                landCode: null,
            }
        }
    }
    info: any = {}
    changeSide() {
        this.resetNewRow()
        this.fetchData()
    }
    fetchData() {
        let type: any = ""
        if (this.activeTab === "PropertyTaxRent") type = 1
        else if (this.activeTab === "PropertyTaxPrice") type = 2
        if (this.activeTab === "PropertyTaxRent" || this.activeTab === "PropertyTaxPrice") {
            Vue.axios
                .get(
                    `property/tax?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&propertyTaxType=${type}`
                )
                .then((res) => {
                    if (this.activeTab === "PropertyTaxPrice") {
                        res.data.rentDtoList.forEach((v: any) => {
                            if (v.contractEndDate != "")
                                v.contractEndDate = this.$utils.strToDate(
                                    v.contractEndDate
                                );
                            if (v.contractStartDate != "")
                                v.contractStartDate = this.$utils.strToDate(
                                    v.contractStartDate
                                );
                            if (v.declarationEndDate != "")
                                v.declarationEndDate = this.$utils.strToDate(
                                    v.declarationEndDate
                                );
                            if (v.declarationStartDate != "")
                                v.declarationStartDate = this.$utils.strToDate(
                                    v.declarationStartDate
                                );
                        });

                    }
                    this.tax = res.data
                    this.time =
                        this.tax.startPeriod.substring(0, 4) +
                        "年" +
                        this.tax.startPeriod.substring(4) +
                        "月" +
                        "至" +
                        this.tax.endPeriod.substring(0, 4) +
                        "年" +
                        this.tax.endPeriod.substring(4) +
                        "月";

                });
        }
        if (this.activeTab === "PropertyTaxInfo") {
            Vue.axios
                .get(
                    `property/tax/info/find?accountBookId=${this.$store.state.accountBook.id}`
                )
                .then((res) => {

                    this.tableList = res.data

                });
        }
    }
    changeRow(row?: any, name?: any) {
        if (name === "taxDeduction" || name === "originValue" || name === "rentIncome"|| name === "declarationStartDate"|| name === "declarationEndDate") row.changeTypeName = name
        if (this.activeTab === "PropertyTaxPrice") {
            // if (row) {
            //     if (row.declarationStartDate != "") {
            //         row.declarationStartDate = this.$utils.simpleDateFormat(row.declarationStartDate, "d");
            //         row.declarationEndDate = this.$utils.simpleDateFormat(row.declarationEndDate, "d");
            //         row.contractStartDate = this.$utils.simpleDateFormat(row.contractStartDate, "d");
            //         row.contractEndDate = this.$utils.simpleDateFormat(row.contractEndDate, "d");
            //     }
            // }
            this.$nextTick(() => {
                this.tax.rentDtoList.forEach((v: any) => {
                    if (v.contractEndDate != "")
                        v.contractEndDate = this.$utils.simpleDateFormat(
                            v.contractEndDate
                            , "d");
                    if (v.contractStartDate != "")
                        v.contractStartDate = this.$utils.simpleDateFormat(
                            v.contractStartDate
                            , "d");
                    if (v.declarationEndDate != "")
                        v.declarationEndDate = this.$utils.simpleDateFormat(
                            v.declarationEndDate
                            , "d");
                    if (v.declarationStartDate != "")
                        v.declarationStartDate = this.$utils.simpleDateFormat(
                            v.declarationStartDate
                            , "d");
                });
            })
        }
        this.$nextTick(() => {
            const taxCopy = JSON.parse(JSON.stringify(this.tax));
            Vue.axios
                .post(
                    `property/tax/save?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                    taxCopy
                )
                .then(() => {
                    this.fetchData();
                });
        })
    }
    changeRent() {
        // const taxCopy = JSON.parse(JSON.stringify(this.tax));
        // console.log(taxCopy)
        Vue.axios
            .post(
                `property/tax/save?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                this.tax
            )
            .then(() => {
                this.fetchData();
            });
    }
    delete() {
        const taxCopy = JSON.parse(JSON.stringify(this.tax));
        Vue.axios
            .post(
                `/property/tax/delete?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                taxCopy
            )
            .then(() => {
                this.fetchData();
            });
    }
    isAdd() {
        if (this.activeTab === "PropertyTaxRent") {
            if ((this.newRow.no !== null && this.newRow.no !== "") &&
                (this.newRow.originValue != "" && this.newRow.originValue != null)) {
                return true
            } else return false
        }
        else if (this.activeTab === "PropertyTaxPrice") {
            let notNull = true
            notNull = this.$utils.notNull([
                this.newRow.no,
                this.newRow.totalArea,
                this.newRow.totalIncome,
                this.newRow.rentIncome,
                this.newRow.declarationStartDate,
                this.newRow.declarationEndDate,
                this.newRow.declarationStartDate,
                this.newRow.contractEndDate,
                // this.bookCode
            ])
            return notNull
        }
    }
    rentDtoList: any = {}
    addRow() {
        this.$nextTick(() => {
            if (
                this.isAdd()
            ) {
                if (this.activeTab === "PropertyTaxRent") {
                    this.priceDtoList = JSON.parse(JSON.stringify(this.tax.priceDtoList));
                    this.priceDtoList.push(this.newRow);
                    this.resetNewRow();
                    this.tax.priceDtoList = this.priceDtoList;
                    this.$nextTick(() => {
                        this.changeRow();

                    })
                }
                if (this.activeTab === "PropertyTaxPrice") {
                    this.newRow.declarationStartDate = this.$utils.simpleDateFormat(this.newRow.declarationStartDate, "d");
                    this.newRow.declarationEndDate = this.$utils.simpleDateFormat(this.newRow.declarationEndDate, "d");
                    this.newRow.contractStartDate = this.$utils.simpleDateFormat(this.newRow.contractStartDate, "d");
                    this.newRow.contractEndDate = this.$utils.simpleDateFormat(this.newRow.contractEndDate, "d");
                    this.tax.rentDtoList.forEach((v: any) => {
                        if (v.contractEndDate != "")
                            v.contractEndDate = this.$utils.simpleDateFormat(
                                v.contractEndDate
                                , "d");
                        if (v.contractStartDate != "")
                            v.contractStartDate = this.$utils.simpleDateFormat(
                                v.contractStartDate
                                , "d");
                        if (v.declarationEndDate != "")
                            v.declarationEndDate = this.$utils.simpleDateFormat(
                                v.declarationEndDate
                                , "d");
                        if (v.declarationStartDate != "")
                            v.declarationStartDate = this.$utils.simpleDateFormat(
                                v.declarationStartDate
                                , "d");
                    });
                    this.rentDtoList = JSON.parse(JSON.stringify(this.tax.rentDtoList));
                    this.$nextTick(() => {
                        this.rentDtoList.push(this.newRow);
                        this.resetNewRow();
                        this.tax.rentDtoList = this.rentDtoList;
                        this.$nextTick(() => {
                            this.changeRent();

                        })
                    })
                }
            } else {
                this.$message.warning("亲，请填写完整数据！");
            }
        })
    }
    remove(index: number) {
        if (this.activeTab === "PropertyTaxRent") {
            if (this.tax.priceDtoList.length === 1) {
                this.tax.priceDtoList = [];
            } else {
                this.tax.priceDtoList.splice(index, 1);
            }
        }
        if (this.activeTab === "PropertyTaxPrice") {
            if (this.tax.rentDtoList.length === 1) {
                this.tax.rentDtoList = [];
            } else {
                this.tax.rentDtoList.splice(index, 1);
            }
        }
        this.delete();
    }
}
